import { createContext } from "react"

import {
  queryWorkflowVerifications as queryWorkflowVerificationsQuery,
  getWorkflowVerification as getWorkflowVerificationQuery,
} from '../graphql/queries'
import { generateClient } from '@aws-amplify/api'
import { useAuthenticator } from '@aws-amplify/ui-react'

const WorkflowVerificationContext = createContext()
export default WorkflowVerificationContext

const ContextState = () => {
  const { user } = useAuthenticator((context) => [context.user])

  // Migrating from Amplify V5 to V6.
  const client = generateClient();

  const authMode = user ? 'userPool' : 'lambda';

  const queryWorkflowVerifications = async ({ searchTerms, orderBy = 'DATE_PLACED_DESC', nextOffset = 0 }) => {
    const limit = 20
    const result = await client.graphql({
      query: queryWorkflowVerificationsQuery,
      authMode: authMode,
      variables: {
        search: {
          searchTerms,
          orderBy,
          pagination: {
            limit,
            offset: nextOffset ? nextOffset : 0,
          },
        },
      },
    })

    return result.data.queryWorkflowVerifications
  }

  const getWorkflowVerification = async ({ orderId }) => {
    const result = await client.graphql({
      query: getWorkflowVerificationQuery,
      authMode: authMode,
      variables: {
        orderId,
      },
    })

    return result.data.getWorkflowVerification
  }

  return {
    queryWorkflowVerifications,
    getWorkflowVerification,
  }
}

const WorkflowVerificationContextProvider = (props) => {
  const state = ContextState()

  return (
    <WorkflowVerificationContext.Provider value={state}>
      {props.children}
    </WorkflowVerificationContext.Provider>
  ) 
}

export { WorkflowVerificationContext, WorkflowVerificationContextProvider }
